module.exports = __webpack_public_path__ + "media/images/v2/star-ac8ea2135e1379656f02ca2eea26cc87.svg";